import { INTERNAL_CONFIG } from '../config/internalConfig';

export const Helpers = () => {
  const size = INTERNAL_CONFIG.floorSize * 2;
  return (
    <>
      <axesHelper args={[size]}/>
    </>
  );
};
